<template>
  <layout-content-tab-nav>
    <!-- Default Slot -->
    <slot></slot>

    <!-- Navbar -->
    <template #navbar="{ launcherDrawer }">
      <div class="navbar-content-container" :class="{ 'expanded-search': shallShowFullSearch }">
        <!-- Left Content: Search -->
        <div class="d-flex align-center">
          <router-link to="/">
            <v-img
              v-if="$vuetify.theme.dark"
              :src="require('@/assets/images/svg/original-logo.svg')"
              height="25"
              width="110"
            ></v-img>
            <v-img
              v-else
              :src="require('@/assets/images/svg/logoDark1.svg')"
              height="30"
              width="120"
            ></v-img>
          </router-link>
        </div>

        <!-- Right Content: I18n, Light/Dark, Notification & User Dropdown -->
        <div class="d-flex align-center">
          <!-- <app-bar-search
            :shall-show-full-search.sync="shallShowFullSearch"
            :data="appBarSearchData"
            :filter="searchFilterFunc"
            :search-query.sync="appBarSearchQuery"
            class="me-4"
          ></app-bar-search> -->
           <v-btn icon @click="openDocumentModal">
            <v-icon color="white">{{ icons.mdiTextBox }}</v-icon>
          </v-btn>
          <!-- <app-bar-theme-switcher class="mx-4"></app-bar-theme-switcher> -->
          <v-btn href="/support" icon ><v-icon :color="light ? 'secondary' : 'white'">{{ icons.mdiFaceAgent  }}</v-icon></v-btn> 
          <app-bar-notification></app-bar-notification>
          <app-bar-user-menu class="ms-2"></app-bar-user-menu>
          <app-launcher-button class="ml-3" @openLauncher="launcherDrawer"></app-launcher-button>
        </div>
      </div>
      <v-overlay
        :value="$store.state.app.shallContentShowOverlay"
        z-index="5"
        absolute
        class="system-bar-overlay"
      ></v-overlay>
    </template>

    <!-- Slot: footer -->
    <!-- <template #footer>
      <div class="d-flex justify-space-between">
        <span
          >COPYRIGHT &copy; {{ new Date().getFullYear() }}
          <a href="https://themeselection.com" class="text-decoration-none">ThemeSelection</a>, All rights
          Reserved</span
        >
        <div class="d-flex align-center">
          <span>Hand-crafted &amp; Made with</span>
          <v-icon color="error" class="ms-2">
            {{ icons.mdiHeartOutline }}
          </v-icon>
        </div>
      </div>
    </template> -->
  </layout-content-tab-nav>
</template>

<script>
// eslint-disable-next-line lines-around-comment
// Search Data
import appBarSearchData from '@/assets/app-bar-search-data'
import AppBarNotification from '@core/layouts/components/app-bar/AppBarNotification.vue'
// App Bar Components
import AppBarSearch from '@core/layouts/components/app-bar/AppBarSearch.vue'
import AppBarUserMenu from '@core/layouts/components/app-bar/AppBarUserMenu.vue'
import LayoutContentTabNav from '@core/layouts/variants/content/horizontal-nav/LayoutContentTabNav.vue'
import { mdiHeartOutline, mdiDotsGrid, mdiFaceAgent, mdiTextBox} from '@mdi/js'
import themeConfig from '@themeConfig'
import store from '@/store'
import { ref, watch } from '@vue/composition-api'
import AppLauncherButton from '../../../../@core/comp-functions/app-launcher/AppLauncherButton.vue'

export default {
  props: {
    light: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    LayoutContentTabNav,
    // App Bar Components
    AppBarSearch,
    // AppBarThemeSwitcher,
    AppBarUserMenu,
    AppBarNotification,
    AppLauncherButton,
  },
  setup() {
    // Search
    const appBarSearchQuery = ref('')
    const shallShowFullSearch = ref(false)
    const maxItemsInGroup = 5
    const totalItemsInGroup = ref({
      pages: 0,
      files: 0,
      contacts: 0,
    })
    watch(appBarSearchQuery, () => {
      totalItemsInGroup.value = {
        pages: 0,
        files: 0,
        contacts: 0,
      }
    })

    const appLaunchModal = ref(false)
    const appLaunch = () => {
      appLaunchModal.value = true
    }
    const searchFilterFunc = (item, queryText, itemText) => {
      if (item.header || item.divider) return true

      const itemGroup = (() => {
        if (item.to !== undefined) return 'pages'
        if (item.size !== undefined) return 'files'
        if (item.email !== undefined) return 'contacts'

        return null
      })()

      const isMatched = itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1

      if (isMatched) {
        if (itemGroup === 'pages') totalItemsInGroup.value.pages += 1
        else if (itemGroup === 'files') totalItemsInGroup.value.files += 1
        else if (itemGroup === 'contacts') totalItemsInGroup.value.contacts += 1
      }

      return (
        appBarSearchQuery.value &&
        isMatched &&
        totalItemsInGroup.value[itemGroup] <= maxItemsInGroup
      )
    }

    const openDocumentModal = () => {
      store.commit('documentation/SET_DOCUMENT_MODAL', true)
    }

    return {
      appLaunch,

      // Search
      appBarSearchQuery,
      shallShowFullSearch,
      appBarSearchData,
      searchFilterFunc,
      openDocumentModal,

      // App Config
      appName: themeConfig.app.name,
      appLogo: themeConfig.app.logo,

      // Icons
      icons: {
        mdiHeartOutline,
        mdiDotsGrid,
        mdiFaceAgent,
        mdiTextBox,
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.app-title {
  font-size: 1.25rem;
  font-weight: 600;
}
.navbar-content-container {
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
  position: relative;
}
</style>
